import { ss } from '@/utils/storage'
import type { WorkspaceFolderDetail } from '@/typings/workspaceFolder'

const LOCAL_NAME = 'workspaceFolderStorage'

export interface WorkspaceFolderState {
  folders: WorkspaceFolderDetail[]
  currentWorkspaceId: number
}

export function defaultWorkspaceFolderState(): WorkspaceFolderState {
  return {
    folders: [],
    currentWorkspaceId: 0,
  }
}

export function getLocalState(): WorkspaceFolderState {
  const localState: WorkspaceFolderState | undefined = ss.get(LOCAL_NAME)
  return { ...defaultWorkspaceFolderState(), ...localState }
}

export function setLocalState(state: WorkspaceFolderState): void {
  ss.set(LOCAL_NAME, state)
}

export function removeLocalState() {
  ss.remove(LOCAL_NAME)
}
